import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import Bg from '../../images/contact/contact-section.png'

const ContactSection = () => {

// notification function  - STARTSSS
function showNotification(type, message) {
    var notification = document.getElementById('notification');
    notification.className = 'notification ' + type;
    notification.innerHTML = message;
    notification.style.display = 'block';

    setTimeout(function() {
        notification.style.opacity = '0';
        setTimeout(function() {
            notification.style.display = 'none';
            notification.style.opacity = '1';
        }, 2000);
    }, 2000);
}

function sendFormDetails(event){
        var form = document.getElementById("my-form");
        var status = document.getElementById("my-form-status");
        var data = new FormData(event.target);
        fetch(event.target.action, {
          method: form.method,
          body: data,
          headers: {
              'Accept': 'application/json'
          }
        }).then(response => 
            {
          if (response.ok) {
            showNotification('success', 'We will reach you soon');
            form.reset()
          } else {
            response.json().then(data => {
              alert("Please try sometimes later!");
            })
          }
        }
        
        ).catch(error => {
            alert("Please try sometimes later!");
        });
      
    }
    // notification function  - ENDSSS 


    const [forms, setForms] = useState({
        name: '',
        email: '',
        date: '',
        time: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            sendFormDetails(e);
            validator.hideMessages();
            setForms({
                name: '',
                email: '',
                message: ''
            });
            document.getElementById("dateValue").value="";
            document.getElementById("timeValue").value="";
        } else {
            validator.showMessages();
        }
    };

    return (
        <section className="contact-section mb-250" style={{ backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-10">
                        <form className="contact-form bg-white mt-100 rmt-0" id="my-form" method="post" action="https://formspree.io/f/xovnowka" onSubmit={submitHandler}>
                            <div className="section-title text-center mb-40">
                                <h2>Request a Visit</h2>
                            </div>
                            <div className="row clearfix">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input
                                            className='form-control'
                                            value={forms.name}
                                            type="text"
                                            name="name"
                                            onBlur={(e) => changeHandler(e)}
                                            onChange={(e) => changeHandler(e)}
                                            placeholder="Name" />
                                        {validator.message('name', forms.name, 'required|alpha_space')}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input
                                            className='form-control'
                                            value={forms.email}
                                            type="email"
                                            name="email"
                                            onBlur={(e) => changeHandler(e)}
                                            onChange={(e) => changeHandler(e)}
                                            placeholder="Email" />
                                        {validator.message('email', forms.email, 'required|email')}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input
                                            className='form-control'
                                            // value={forms.date}
                                            type="text"
                                            name="date"
                                            id="dateValue"
                                            // onBlur={(e) => changeHandler(e)}
                                            // onChange={(e) => changeHandler(e)}
                                            placeholder="Date" />
                                        {/* {validator.message('date', forms.date, 'required|alpha_space')} */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input
                                            className='form-control'
                                            // value={forms.time}
                                            type="text"
                                            name="time"
                                            id="timeValue"
                                            // onBlur={(e) => changeHandler(e)}
                                            // onChange={(e) => changeHandler(e)}
                                            placeholder="Time" />
                                        {/* {validator.message('time', forms.time, 'required|alpha_space')} */}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <textarea
                                            className='form-control'
                                            rows="4"
                                            onBlur={(e) => changeHandler(e)}
                                            onChange={(e) => changeHandler(e)}
                                            value={forms.message}
                                            type="text"
                                            name="message"
                                            placeholder="Message">
                                        </textarea>
                                        {validator.message('message', forms.message, 'required')}

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button type="submit" className="theme-btn mt-40">Send</button>
                                </div>
                            </div>
                            <div className="title-rotated">contact</div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;